// Date-fns docs: https://date-fns.org/v2.13.0/docs/format
export const LOCAL_TIME = 'p' // moment equivilant: LT
export const LOCAL_DATE = 'P' // moment equivilant: L
export const FULL_LOCAL_TIME = 'EEEE, LLLL d, yyyy p' // moment equivilant: LLLL
export const DATE =  'LLLL d, yyyy' // moment equivilant: LL
export const HHmm = 'HH:mm' //  24 hour time -- moment equivilant: HH:mm
export const SHORT_DAY = 'EEE' // moment equivilant: ddd
export const ISO_8601 = "yyyy-MM-dd'T'HH:mm:ss.SSS"